import Model from '@/store/plugins/orm/Model'
import { Shift, User, AppEvent } from './ModelRepository'

import ApiService from '@/services/ApiService';
import HashGen from '@/utilities/HashGen';

export class UserTransaction extends Model {
    static get entity() {
        return 'user_transactions';
    }

    static get primaryKey() {
        return 'hash';
    }

    static get DATE_FORMAT() {
        return 'YYYY-MM-DDTHH:mm:ssZ';
    }

    static get TYPE_CASH() {
        return 'cash';
    }
    static get TYPE_DEPOSIT() {
        return 'deposit';
    }
    static get TYPE_CHARGE() {
        return 'charge';
    }

    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.regular()),
            user_id: this.attr(null),
            shift_id: this.attr(null),
            shift_hash: this.attr(null),
            amount: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
            type: this.attr(null),
            issued_at: this.attr(null),

            shift: this.belongsTo(Shift, 'shift_hash'),
            user: this.belongsTo(User, 'user_id'),

            sync_needed: this.attr(null)
        };
    }

    /**
     * Sync the data with the server
     */
    async sync() {
        if (!this.$store().getters.isOnline) {
            this.$save();
            return { success: true };
        }

        try {
            const response = await ApiService.post(`/users/${this.user_id}/transactions`, this.$toJson())
            this.$fill(response.data);
            UserTransaction.insert({ data: [response.data] });

            AppEvent.build('userUpdate', { id: response.data.id }).send()

            return { success: true };
        } catch(error) {
            return { success: false };
        }
    }

    getAmount() {
        return Money.parse(this.amount);
    }
}

export default UserTransaction
